export const RQ_SECTION_ACTIONS = {
    ADD_SECTION: "addSectionState",
    UPDATE_SECTION: "updateSectionValue",
    REMOVE_SECTION: "removeSectionState",
    COLLAPSE_ALL: "collapseAllSections",
    EXPAND_ALL: "expandAllSections",
    RESET_STATE: "resetRqSectionsState"
};